import { render, staticRenderFns } from "./overview-chart-card.vue?vue&type=template&id=32dd3252&scoped=true&"
import script from "./overview-chart-card.vue?vue&type=script&lang=js&"
export * from "./overview-chart-card.vue?vue&type=script&lang=js&"
import style0 from "./overview-chart-card.vue?vue&type=style&index=0&id=32dd3252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd3252",
  null
  
)

export default component.exports